import React from "react";
import NavbarClient from "./NavbarClient";

// Props interface
interface NavbarProps {
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
  onLogoClick?: () => void;
  isCollapsed: boolean;
  isMobile: boolean;
  sidebarWidth: number;
}

// Server Component - Estructura estática + Client Component para interactividad
const Navbar: React.FC<NavbarProps> = ({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  onLogoClick,
  isCollapsed,
  isMobile,
  sidebarWidth,
}) => {
  return (
    <nav
      className={`fixed top-0 h-16 bg-[var(--color-background)] text-[var(--color-primary)] px-4 py-2 flex flex-col gap-2 md:flex-row items-center justify-between shadow-lg transition-all duration-500`}
      style={{
        left: isMobile ? 0 : sidebarWidth,
        right: 0,
        width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
      }}
    >
      <NavbarClient
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        onLogoClick={onLogoClick}
        isCollapsed={isCollapsed}
      />
    </nav>
  );
};

export default Navbar;
